import { Archivo } from "../core.models/archivo";
import { GQLQuerySpec, queryType } from "../core.utilidades/graphql-utils";

const type = Archivo;
const typeName = 'Archivo';

export const ArchivoQuery = {
    paramType: typeName,

    obtenerById: new GQLQuerySpec({
        queryType: queryType.QUERY,
        methodName: 'obtener' + typeName + 'ById',
        fields: type.getFields(),
    }),

    generarPdfColectivoCompanniaAnonimo: new GQLQuerySpec({
        queryType: queryType.MUTATION,
        methodName: 'generarPdfColectivoCompanniaAnonimo',
        fields: type.getFields(),
    }),

    generarPdfColectivoCompanniaCompleto: new GQLQuerySpec({
        queryType: queryType.MUTATION,
        methodName: 'generarPdfColectivoCompanniaCompleto',
        fields: type.getFields(),
    }),

    generarPdfIndividualCompanniaAnonimo: new GQLQuerySpec({
        queryType: queryType.MUTATION,
        methodName: 'generarPdfIndividualCompanniaAnonimo',
        fields: type.getFields(),
    }),

    generarPdfIndividualCompanniaCompleto: new GQLQuerySpec({
        queryType: queryType.MUTATION,
        methodName: 'generarPdfIndividualCompanniaCompleto',
        fields: type.getFields(),
    }),

    generarPdfColectivoCobertura: new GQLQuerySpec({
        queryType: queryType.MUTATION,
        methodName: 'generarPdfColectivoCobertura',
        fields: type.getFields(),
    }),
    
    generarPdfIndividualCobertura: new GQLQuerySpec({
        queryType: queryType.MUTATION,
        methodName: 'generarPdfIndividualCobertura',
        fields: type.getFields(),
    }),
    
    generarPdfSolicitud: new GQLQuerySpec({
        queryType: queryType.MUTATION,
        methodName: 'generarPdfSolicitud',
        fields: type.getFields(),
    }),
    
    generarPdfSolicitudReducirCapital: new GQLQuerySpec({
        queryType: queryType.MUTATION,
        methodName: 'generarPdfSolicitudReducirCapital',
        fields: type.getFields(),
    }),
    
    generarPdfSolicitudCambiarBeneficiarios: new GQLQuerySpec({
        queryType: queryType.MUTATION,
        methodName: 'generarPdfSolicitudCambiarBeneficiarios',
        fields: type.getFields(),
    }),

    rellenarPdfSolicitud: new GQLQuerySpec({
        queryType: queryType.MUTATION,
        methodName: 'rellenarPdfSolicitud',
        fields: type.getFields(),
    }),

    rellenarAkibuPdf: new GQLQuerySpec({
        queryType: queryType.MUTATION,
        methodName: 'rellenarAkibuPdf',
        fields: type.getFields(),
    }),
   
    rellenarAkibuPdfSinNumeroPoliza: new GQLQuerySpec({
        queryType: queryType.MUTATION,
        methodName: 'rellenarAkibuPdfSinNumeroPoliza',
        fields: type.getFields(),
    }),

    findAllByClienteId: new GQLQuerySpec({
        queryType: queryType.PERSONALIZADA,
        queryPersonalizada: 'query q ($clienteId: Long!) { content: methodName# (clienteId: $clienteId) { fields# }  }',
        methodName: 'findAllByClienteId',
        fields: type.getFields(),
    }),
}